import {connect, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import React, {useCallback, useMemo, useRef, useState} from "react";
import {
    CAlert,
    CButton,
    CCol,
    CForm,
    CFormInput, CFormSelect,
    CInputGroup,
    CInputGroupText, CModal, CModalBody,
    CModalHeader, CModalTitle,
    CRow
} from "@coreui/react";
import numeral from "numeral";
import {AgGridReact} from "ag-grid-react";
import * as api from "../../../api/api";
import {Loading} from "../../../components/common";
//import StoreListWhere from "../where/StoreListWhere";
import BrandListWhere from "../where/BrandListWhere";
import StoreDetail from "../store/StoreDetail";
import {currencyFormatter} from "../../../config/formatter";
import StoreCornerListWhere from "../where/StoreCornerListWhere";

const ProductPrice = (props) => {
    const {user} = useSelector((props) => props.account);

    const gridRef = useRef();
    const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({visible: false, message: ""});
    const [gridData, setGridData] = useState([]);
    const [searchForm, setSearchForm] = useState({
        cmpCd: "",
        brandCd: "",
        storeCd: "",
        productCd: "",
        productNm: "",
        barcode: ""
    });
    const [brandData, setBrandData] = useState([]);
    const [brandPriceData, setBrandPriceData] = useState([]);

    const [selectProduct, setSelectProduct] = useState({});
    const [selectNationCd, setSelectNationCd] = useState("US");
    const [selectProductInfo, setSelectProductInfo] = useState({productNm: "", origin: "", nutrient: "", nationCd: "US"});

    const defaultColDef = {
        flex: 1,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true
    };

    const [columnDefs] = useState([
        {field: "brandCd", headerName: "휴게소코드", width: 100},
        {field: "brandNm", headerName: "휴게소명", width: 200}
    ]);

    const [detailColumnDefs] = useState([
        {field: "cmpCd", headerName: "회원사코드",  width: 130, hide:true},
        {field: "brandCd", headerName: "브랜드코드",  width: 130, hide:true},
        {field: "brandNm", headerName: "휴게소명",  width: 130},
        {field: "productCd", headerName: "상품코드", hide:true, width: 130},
        {field: "restProductCd", headerName: "상품코드", width: 130},
        {field: "productNm", headerName: "상품명"},
        {field: "price", headerName: "기준 판매가", minWidth: 100, valueFormatter: currencyFormatter},
        {field: "brandPrice", headerName: "변경 판매가", editable: true, minWidth: 100, valueFormatter: currencyFormatter}
    ]);

    const handleSelect = (code, value) => {
        if (value === "C") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: code
            }));
        } else if (value === "B") {
            setSearchForm((state) => ({
                ...state,
                brandCd: code
            }));
        } else if (value === "S") {
            setSearchForm((state) => ({
                ...state,
                storeCd: code
            }));
        } else if (value === "O") {
            setSearchForm((state) => ({
                ...state,
                cornerCd: code
            }));
        }
        console.log("변경 시 brandCd : ", searchForm.brandCd);
    };


    const save = async () => {
        console.log("저장");

        const {cmpCd, brandCd} = searchForm;
        console.log("searchForm::", searchForm);

        gridRef.current.api.stopEditing();

        // 딜레이를 주자updateRows
        setTimeout(() => {
            console.log(">>> 저장 시 rows :: ", updateRows);
            setLoading(true);

            if(updateRows.length === 0){
                alert("변경된 데이터가 없습니다.");
                return;
            }

            api.putProductPrice(updateRows).then((result) => {
                const {responseBody, responseCode, responseMessage} = result.data;
                if (responseCode === "200") {
                    alert("처리되었습니다.");
                    search();
                }
            })
            .catch((e) => {
                console.log("### error :: ", e.message);
            })
            .finally(() => {
                setLoading(false);
            })
        }, 200);

    }


    const search = () => {
        setError({
            visible: false,
            message: ""
        });

        //console.log("상품목록 data::: ", data);

        const {cmpCd, brandCd, storeCd} = searchForm;

        console.log("searchForm::", searchForm);

        console.log("조회 시  brandCd.length::: ", brandCd.length);

        if (brandCd.length === 0) {
            setError({
                visible: true,
                message: "조회시 휴게소는 반드시 선택하셔야 합니다."
            });
            return;
        }

        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            restProductCd: searchForm.restProductCd,
            productNm: searchForm.productNm,
            barcode: searchForm.barcode,
            isUse : "Y"
        };

        setLoading(true);

        api.getProductPrice(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            if (responseCode === "200") {
                console.log("result : ", responseBody);
                [responseBody.brandCd] = brandCd;

                setLoading(false);
                setBrandPriceData(responseBody);
            }
        });

    };

    const onCellEditingStopped = (e) => {
        getUpdateRows(e);
    }

    let updateRows = [];

    const getUpdateRows = (e) => {
        const {cmpCd, brandCd, storeCd} = props.selected;
        const colId = e.column.colId;

        if (e.oldValue !== e.newValue) {
            const data = {
                cmpCd: e.data.cmpCd,
                brandCd: e.data.brandCd,
                productCd: e.data.productCd,
                price: e.data.brandPrice,
                costPrice: 0, //e.data.costPrice,
                subPrice: 0, //e.data.subPrice,
                instUser : user.userId,
                updUser: user.userId,
                useYn: "Y"
            }
            updateRows.push(data);
        }

        console.log(">>> update rows :: ", updateRows);
    }

    const onRowSelected = useCallback((event) => {
        console.log("event.node.data:: ", event.node.data);
        getProductPrice(event.node.data);
        //setSelectProduct(event.node.data);
        //setModalVisible(true);
    }, []);


    /*화면 영역 Grid Start*/
    return (
     <>
         {loading ? <Loading/> : null}
         {error.visible ? <CAlert color="danger">{error.message}</CAlert> : null}
         <div style={containerStyle}>
             <div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
                 <h5>휴게소별 상품가격 관리</h5>
                 <div>
                     <CButton size={"sm"} style={{marginRight: 10}} color="primary" onClick={save}>저장</CButton>
                     <CButton size={"sm"} color="primary" onClick={search}>조회</CButton>
                 </div>
             </div>

             <StoreCornerListWhere type={"S"} account={props.account} selected={searchForm} onSelect={(c, v) => handleSelect(c, v)}/>
             <CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
             <CCol xs={12}>
                 <CInputGroup size={"sm"} className={"mb-1"}>
                     <CInputGroupText style={{ width: 80 }}>상품코드</CInputGroupText>
                     <CFormInput id="productCd"
                                 style={{height: 35}}
                                 onChange={(e) => {
                                     setSearchForm((state) => ({
                                         ...state,
                                         restProductCd: e.target.value
                                     }));
                                 }}/>
                 </CInputGroup>
             </CCol>
             <CCol xs={12}>
                 <CInputGroup size={"sm"} className={"mb-1"}>
                     <CInputGroupText style={{ width: 80 }}>상품명</CInputGroupText>
                     <CFormInput id="productNm"
                                 style={{height: 35}}
                                 onChange={(e) => {
                                     setSearchForm((state) => ({
                                         ...state,
                                         productNm: e.target.value
                                     }));
                                 }}/>
                 </CInputGroup>
             </CCol>
             <CCol xs={12}>
                 <CInputGroup size={"sm"} className={"mb-1"}>
                     <CInputGroupText style={{ width: 80 }}>바코드</CInputGroupText>
                     <CFormInput id="barcode"
                                 style={{height: 35}}
                                 onChange={(e) => {
                                     setSearchForm((state) => ({
                                         ...state,
                                         barcode: e.target.value
                                     }));
                                 }}/>
                 </CInputGroup>
             </CCol>
             </CForm>

             <div>
                 <CRow>
                     <CCol >
                         <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
                             상품목록(휴게소별 판매가 변경)
                         </div>
                         <div className="ag-theme-alpine" style={{width: "100%", height: 450, marginTop: 10}}>
                             <AgGridReact
                                 ref={gridRef}
                                 rowSelection={"single"}
                                 headerHeight={30}
                                 rowHeight={30}
                                 rowData={brandPriceData}
                                 animateRows={true}
                                 pagination={true}
                                 localeText={{noRowsToShow: "조회 결과가 없습니다."}}
                                 onCellEditingStopped={onCellEditingStopped}
                                 defaultColDef={defaultColDef}
                                 columnDefs={detailColumnDefs}>
                             </AgGridReact>
                         </div>
                     </CCol>

                 </CRow>
             </div>



         </div>
     </>
    ) //End return 화면영역

}

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(ProductPrice);
